import { SparklesIcon } from '@heroicons/react/24/solid'
import React from 'react'
import { decodeToken } from 'react-jwt'
import { useSelector } from 'react-redux'

import { token } from '../../util/constants'
import { loadStateFn } from '../../util/localStorage'

const SOCIAL_LOOP_AI_SIDEBAR_URL =
  'https://socialloopai.com/?utm_source=dripshipper&utm_medium=sidebar&utm_campaign=dripshipper_social_loop_ai&utm_content=nav_promo'

const isShopifyEmailDomain = (email) => {
  if (!email || typeof email !== 'string') return false
  const domain = email.split('@')[1]
  if (!domain) return false
  return domain.toLowerCase().includes('shopify')
}

const SidebarSocialLoopPromo = () => {
  const profileEmail = useSelector(
    (state) => state.settings?.userProfile?.email,
  )
  const authEmail = useSelector((state) => state.auth?.userData?.email)
  const tokenEmail = decodeToken(loadStateFn(token))?.email
  const email = profileEmail || authEmail || tokenEmail

  if (isShopifyEmailDomain(email)) {
    return null
  }

  return (
    <div
      className="rounded-lg border border-solid border-[rgba(215,197,185,0.45)] p-4 shrink-0"
      role="complementary"
      aria-label="Social Loop marketing promotion"
    >
      <SparklesIcon
        className="h-4 w-4 text-light-coffee mb-2"
        aria-hidden="true"
      />
      <p className="font-semibold text-white text-sm mb-1.5">
        Want help with marketing?
      </p>
      <p className="text-sm text-light-coffee leading-relaxed mb-3">
        Create ads and social posts like the big brands.
      </p>
      <a
        href={SOCIAL_LOOP_AI_SIDEBAR_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm text-white underline hover:opacity-90 focus:outline-none"
      >
        Try Social Loop &rarr;
      </a>
    </div>
  )
}

export default SidebarSocialLoopPromo
